if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.isCarousel = this.hasAttribute('data-carousel');
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // Preload the rest of the carousel images AFTER the lightbox has opened
        // and painted. Doing it synchronously on the click (and with
        // decoding:'sync') blocked the main thread for hundreds of ms — up to
        // several seconds on high-res wallpapers — which was the worst gallery
        // INP. Defer to idle so the open feels instant.
        if (this.isCarousel) {
          const preload = () => this.preloadAllImages();
          if ('requestIdleCallback' in window) {
            requestIdleCallback(preload, { timeout: 800 });
          } else {
            requestAnimationFrame(() => setTimeout(preload, 0));
          }
        }
      }

      loadImage(img) {
        img.loading = 'eager';
        img.decoding = 'async';
        // Restore responsive candidates first to avoid an extra 2048px request.
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          delete img.dataset.srcset;
        }
        if (img.dataset.src) {
          img.src = img.dataset.src;
          delete img.dataset.src;
        }
      }

      preloadAllImages() {
        if (!this.hasAttribute('open')) return;
        // Carousel photos are direct IMG children; virtual slides wrap their images.
        this.querySelectorAll('img[data-media-id], [data-media-id] img').forEach((img) => {
          this.loadImage(img);
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        if (activeMedia.tagName === 'IMG') this.loadImage(activeMedia);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // Only scroll into view if not carousel mode
        if (!this.isCarousel) {
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
